import { PaymentStatus } from "../../types/payment-statuses";
import { CommissionStatus } from "../../types/commission-statuses";

export const TAB_OPTIONS = {
  OTHER: 'other',
  IN_STORE: 'in_store'
} as const;

export type TabOption = typeof TAB_OPTIONS[keyof typeof TAB_OPTIONS];

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PAGE_SIZE_SMALL = 50;

export const SEARCH_RESULTS_SIZE = 5;

export const PAYMENT_STATUSES = [PaymentStatus.PAID, PaymentStatus.NOT_PAID] as const;

export const OTHER_STATUSES = [
  CommissionStatus.NEW, 
  CommissionStatus.PENDING, 
  CommissionStatus.ACCEPTED, 
  CommissionStatus.REJECTED, 
  CommissionStatus.COMPLETED, 
  CommissionStatus.SOLD, 
  CommissionStatus.RETURNED_TO_CUSTOMER
] as const;

export type PaginationInfo = {
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
};

export const DEFAULT_MANUAL_COMMISSION = {
  brideName: '',
  brideSurname: '',
  bridePhone: '',
  brideEmail: '',
  brideSocial: '',
  dress: '',
  dressSize: '',
  purchaseYear: '',
  purchasePriceAmount: undefined,
  purchasePriceCurrency: 'EUR',
  desiredSalePriceAmount: undefined,
  desiredSalePriceCurrency: 'EUR',
  status: CommissionStatus.NEW,
  acceptedDate: '',
  endDate: '',
  payment: PaymentStatus.NOT_PAID,
  attachments: [],
  shareLink: '',
  contracts: [],
  submissionDate: new Date().toISOString().split('T')[0],
  itemReceived: false,
};
